module.exports = "<section class=\"home\">\n  <h1 align=\"center\">Welcome!</h1>\n  <div align= \"center\">\n    <img src=\"/assets/img/logo-nobg_300.png\">\n  </div>\n  <h2 align=\"center\">Website is under construction meanwhile check <a href=\"https://github.com/pksprojects\">here</a>.</h2>\n</section>\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/vsts/work/1/s/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1